module.exports = __webpack_public_path__ + "img/2_200.ec934a8c.png";